const firebaseConfig = {
  apiKey: "AIzaSyDicQvzT6FAGO3O1_NPpymmkz4eBCKqoD0",
  authDomain: "hp-tech.firebaseapp.com",
  projectId: "hp-tech",
  storageBucket: "hp-tech.appspot.com",
  messagingSenderId: "1077182841027",
  appId: "1:1077182841027:web:b08a91b1055411412de276"
};

export default firebaseConfig;